// Vue
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
// Template
import template from "./template.vue";
import { ImageAspectRatio } from "../../../../components/image_aspect_ratio/ImageAspectRatio";

@Component({
  mixins: [template],
  components: {
    ImageAspectRatio,
  },
})
export default class KonsiItem extends Vue {
  @Prop()
  public konsi!: any;

  @Prop()
  public translation!: object;

  public downloadDocument() {}

  public openDetail() {
    this.$emit("openDetail", this.konsi);
  }
}
